import script from "./index2.vue?vue&type=script&setup=true&lang=js"
export * from "./index2.vue?vue&type=script&setup=true&lang=js"

import "./index2.vue?vue&type=style&index=0&id=e869196c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e869196c"]])

export default __exports__